<script>
  import { getContext } from 'svelte';
  import FixedContent from '../FixedContent/FixedContent.svelte';

  const state = getContext('state');

  const nav = [
    { label: 'Table', key: 'table', highlighted: false },
    { label: 'Graphs', key: 'graphs', highlighted: false },
  ];

  const onClick = (val) => {
    $state.view = val;

    if (!$state.disableEvents) {
      gtag('event', 'Change View', {
        'event_category': val
      });
    }
  }
</script>

<FixedContent>
  <div class="flex">
    {#each nav as n, i}
      <div
        class="flex-none  cursor-pointer  px-4  py-2  rounded  border  border-gray-500 {i > 0 ? 'ml-4' : ''} {n.key === $state.view ? 'bg-gray-700  text-white' : 'bg-white  text-gray-700'}"
        on:click={() => onClick(n.key)}
      >
        {n.label}
      </div>
    {/each}
  </div>
</FixedContent>
